var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"justify-space-between":""}},[_c('v-flex',{attrs:{"xs4":"","text-xs-left":""}},[_vm._v(_vm._s(_vm.label))]),_c('v-flex',{attrs:{"xs4":"","text-xs-right":""}},[_vm._v(_vm._s(_vm.formatVal(_vm.value)))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }